import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
  Divider,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import ResizablePanels from 'resizable-panels-react';
import { HotTable } from '@handsontable/react';
import { registerAllModules } from 'handsontable/registry';
import { HandsonTableKey } from '../../settings/shared/constants';
import CsvLoad from './CsvLoad';
import RunService from 'services/api/Run';
import '../../assets/css/catalog.css';
import ScaleLoader from 'react-spinners/ScaleLoader';
import LoadingOverlay from 'react-loading-overlay';
import Handsontable from 'handsontable';
import Select from 'react-select';
import StorageService from '../../services/api/Storage';
import page404 from 'assets/img/404.png';
import axios from 'axios';
import '../../assets/css/catalog.css';
import {CSVToJSONs} from "settings/shared/commonMethod";
import { HyperFormula } from 'hyperformula';


// register Handsontable's modules
registerAllModules();
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const delimiteroptions = [
  { label: 'Comma Seperated Value (,)', value: ',' },
  { label: 'Pipe Seperated Value (|)', value: '|' },
];

function renderNewCell(instance, td, row, col, prop, value, cellProperties) {
  td.style.background = '#21ad1c';
  td.style.color = '#fff';
  td.style.fontWeight = 'bold';
  Handsontable.renderers.TextRenderer.apply(this, arguments);
}

function renderSameCell(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.style.fontWeight = 'bold';
}

function renderDiffCell(instance, td, row, col, prop, value, cellProperties) {
  td.style.background = '#db3125';
  td.style.color = '#fff';
  td.style.fontWeight = 'bold';
  Handsontable.renderers.TextRenderer.apply(this, arguments);
}

export default class CsvDiff extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadCsvDiffComponent: false,
      csvFileOneContent: '',
      chartHeader: [],
      errorFile: '',
      fileName: '',
      fileType: '',
      totalPages: 0,
      delimiter: ',',
      activePage: 1,
      totalRecords: 0,
      loading: false,
      storageId: '',
      rootFolder: '',
      csvFileOneData: [],
      csvFileTwoData: [],
      csvFileTwoContent: [],
      diffChartHeader: [],
      DownloadUrlFileOne: '',
      DownloadUrlFileTwo: '',
    };
    this.hotformula = {
      formulas: {
        engine: HyperFormula,
      }
    }
  }

  componentDidMount() {
    this.setState({ loadCsvDiffComponent: true, loading: true });
    if (this.props?.selectedFiles[0]?.endsWith('csv')) {
      let fileName = this.props?.selectedFiles[0].substring(
        0,
        this.props?.selectedFiles[0].lastIndexOf('/')
      );
      let version = this.props?.selectedFiles[0].substring(
        this.props?.selectedFiles[0].lastIndexOf('/') + 1
      );
      let updatedFileName = fileName?.substring(fileName.indexOf('_') + 1);
      let FileName = updatedFileName +'/'+version;   
      this.downloadObjForFileOne(FileName,this.state.storageId,this.state.rootFolder)
    }
     else if (!this.props?.selectedFiles[0]?.endsWith('csv')) {
      let fileName = this.props?.selectedFiles[0].substring(
        0,
        this.props?.selectedFiles[0].lastIndexOf('/')
      );
      let version = this.props?.selectedFiles[0].substring(
        this.props?.selectedFiles[0].lastIndexOf('/') + 1
      );
      let updatedFileName = fileName?.substring(fileName.indexOf('_') + 1);
      let FileName = updatedFileName;  
      this.downloadVersionUrlForFileOne(FileName, version);
    }

    if (this.props?.selectedFiles[1]?.endsWith('csv')) {
      let fileName = this.props?.selectedFiles[1].substring(
        0,
        this.props?.selectedFiles[1].lastIndexOf('/')
      );
      let version = this.props?.selectedFiles[1].substring(
        this.props?.selectedFiles[1].lastIndexOf('/') + 1
      );
      let updatedFileName = fileName?.substring(fileName.indexOf('_') + 1);
      let FileName = updatedFileName +'/'+version; 
      this.downloadObjForFileTwo(FileName,this.state.storageId,this.state.rootFolder)
    } 
    else if (!this.props?.selectedFiles[1]?.endsWith('csv')) {
      let fileName = this.props?.selectedFiles[1].substring(
        0,
        this.props?.selectedFiles[1].lastIndexOf('/')
      );
      let version = this.props?.selectedFiles[1].substring(
        this.props?.selectedFiles[1].lastIndexOf('/') + 1
      );
      let updatedFileName = fileName?.substring(fileName.indexOf('_') + 1);
      let FileName = updatedFileName; 
      this.downloadVersionUrlForFileTwo(FileName, version);
    }
  }

  downloadObjForFileOne = (myPath, sId, root) =>{
    StorageService.downloadObjectUrl(myPath, sId, root)
    .then((response) => {
      if(response !== null && response !== undefined && response.hasOwnProperty("download_url")){
        this.renderTextForFileOne(response.download_url);
      }
    }).catch((error) => {
      this.state.fileType = 'png'
      this.state.myContent = page404
      this.state.fileName = 'File Not Found!!!'
      this.setState({ loading: false });
    });
  }
  downloadObjForFileTwo = (myPath, sId, root) =>{
    StorageService.downloadObjectUrl(myPath, sId, root)
    .then((response) => {
      if(response !== null && response !== undefined && response.hasOwnProperty("download_url")){
        this.renderTextForFileTwo(response.download_url);
      }
    }).catch((error) => {
      this.state.fileType = 'png'
      this.state.myContent = page404
      this.state.fileName = 'File Not Found!!!'
      this.setState({ loading: false });
    });
  }


  downloadVersionUrlForFileOne = (fileName, version) => {
    StorageService.downloadVersionFilesUrl(
      fileName,
      version,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        this.renderTextForFileOne(response.download_url);
        this.setState({ DownloadUrlFileOne: response.download_url });
      })
      .catch((error) => {
        this.state.fileType = 'png';
        this.state.myContent = page404;
        this.state.fileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  downloadVersionUrlForFileTwo = (fileName, version) => {
    StorageService.downloadVersionFilesUrl(
      fileName,
      version,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        this.renderTextForFileTwo(response.download_url);
        this.setState({ DownloadUrlFileTwo: response.download_url });
      })
      .catch((error) => {
        this.state.fileType = 'png';
        this.state.myContent = page404;
        this.state.fileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  renderTextForFileOne = (url) => {
    this.setState({
      loading: true,
    });
    if (
      this.state.fileType == 'jpeg' ||
      this.state.fileType == 'jpg' ||
      this.state.fileType == 'png'
    ) {
      this.setState({
        myContent: url,
      });
    } else {
      axios.get(url).then((response) => {
          if(response.data !== null && response.data.length > 0){
            let result = CSVToJSONs(response.data,this.state.delimiter); 
            this.setState({
              csvFileOneContent: result,
              csvFileOneData:result,
              loading: false
          })  
        }
          else{
          this.setState({
            csvFileOneContent: [], // Empty the csv content value
            csvFileOneData:[],

          });
          }
        
      });
    }
  };
  renderTextForFileTwo = (url) => {
    this.setState({
      loading: true,
    });
    if (
      this.state.fileType == 'jpeg' ||
      this.state.fileType == 'jpg' ||
      this.state.fileType == 'png'
    ) {
      this.setState({
        myContent: url,
      });
    } else {
      axios.get(url).then((response) => {
          if(response.data !== null && response.data.length > 0){
            let result = CSVToJSONs(response.data,this.state.delimiter); 
            this.setState({
              csvFileTwoContent: result,
              csvFileTwoData:result,
              loading: false
          })          
        }
        else{
          this.setState({
            csvFileTwoContent: [], // Empty the csv content value
            csvFileTwoData:[]
          });
          }
       });
    }
  };

  splitData = (data) => {
    let upperSplit = data.split(/\r\n|\n\r|\n|\r/);
    upperSplit.length = upperSplit.length - 1;
    let deepSplit = upperSplit?.map((item) => {
      let itemList = item.split(this.state.delimiter);
      return itemList;
    });

    return deepSplit;
  };

  setWholeGraphData = (csvArray) => {
    var wholeArray = csvArray; // to swab column to rows
    let getHeaders = csvArray.length > 0 ? csvArray[0] : '';
    var Headers = [];
    if(getHeaders !== ""){
      getHeaders.forEach(function (key) {
        Headers.push({
          label: key,
          value: key,
        });
      });
    }
    let data = {
      headers: Headers,
      wholeArray: wholeArray,
    };
    return data;
  };

  InitGraphDataPaginate = (header, jsonCsv) => {
    let csvFormat = CsvLoad.convertCsvFormat(jsonCsv); // convert array of json object to csv format
    let csvArray = CsvLoad.CSVParseToArray(csvFormat); // convert csv to array
    var wholeArray = csvArray; // to swab column to rows
    let getHeaders = csvArray.length > 0 ? csvArray[0] : '';
    var Headers = [];
    if(getHeaders !== ""){
      getHeaders.forEach(function (key) {
        Headers.push({
          label: key,
          value: key,
        });
      });
    }
    let data = {
      headers: Headers,
      wholeArray: wholeArray,
    };

    return data;
  };

  csvLoadDataForFileTwo = (page) => {
    let csvPath = {
      // for removing prfix from the file name added in parent
      path: this.props.selectedFiles[1]?.substring(
        this.props.selectedFiles[1].indexOf('_') + 1
      ),
      delimiter: this.state.delimiter,
      storageId: this.state.storageId,
      rootFolder: this.state.rootFolder,
    };
    RunService.csvDataPagination(
      csvPath,
      page,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        try {
          if (response.records.length !== 0) {
            this.setState({
              csvFileTwoContent: [], // Empty the csv content value
            });
            let jsonCsv = [];

            for (const record of response?.records) {
              var removeSlash = record.replace(/\\/g, '');
              let obj = JSON.parse(removeSlash);
              jsonCsv.push(obj);
            }
            this.setState(
              {
                csvFileTwoContent: jsonCsv,
                totalPages: response.totalPages,
                totalRecords: response.totalRecords,
                loading: false,
              },
              () => {
                let result = this.InitGraphDataPaginate(
                  response.records[0],
                  jsonCsv
                );
                this.setState({
                  diffChartHeader: result.headers,
                  csvFileTwoData: result.wholeArray,
                });
              }
            );
          } else {
            this.setState({
              csvFileTwoContent: [],
              totalPages: 0,
              totalRecords: 0,
              loading: false,
            });
          }
        } catch (err) {
          this.setState({
            csvFileTwoContent: [],
            totalPages: 0,
            totalRecords: 0,
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          errorFile: 'Invalid CSV File',
          csvFileTwoContent: [],
          totalPages: 0,
          totalRecords: 0,
          loading: false,
        });
      });
  };

  csvLoadDataForFileOne = (page) => {
    this.setState({
      loading: true,
    });
    let csvPath = {
      // for removing prfix from the file name added in parent
      path: this.props.selectedFiles[0]?.substring(
        this.props.selectedFiles[0].indexOf('_') + 1
      ),
      delimiter: this.state.delimiter,
      storageId: this.state.storageId,
      rootFolder: this.state.rootFolder,
    };
    RunService.csvDataPagination(
      csvPath,
      page,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        try {
          if (response.records.length !== 0) {
            this.setState({
              csvFileOneContent: [], // Empty the csv content value
            });
            let jsonCsv = [];
            for (const record of response?.records) {
              var removeSlash = record.replace(/\\/g, '');
              let obj = JSON.parse(removeSlash);
              jsonCsv.push(obj);
            }
            this.setState(
              {
                csvFileOneContent: jsonCsv,
                totalPages: response.totalPages,
                totalRecords: response.totalRecords,
              },
              () => {
                let result = this.InitGraphDataPaginate(
                  response.records[0],
                  jsonCsv
                );

                this.setState(
                  {
                    chartHeader: result.headers,
                    csvFileOneData: result.wholeArray,
                  },
                  () => {
                    if (this.props?.selectedFiles[1]?.endsWith('csv')) {
                      this.csvLoadDataForFileTwo(this.state.activePage);
                    } else {
                      let fileName = this.props?.selectedFiles[1].substring(
                        0,
                        this.props?.selectedFiles[1].lastIndexOf('/')
                      );
                      let version = this.props?.selectedFiles[1].substring(
                        this.props?.selectedFiles[1].lastIndexOf('/') + 1
                      );
                      this.downloadVersionUrlForFileTwo(fileName, version);
                    }
                  }
                );
              }
            );
          } else {
            this.setState({
              csvFileOneContent: [],
              totalPages: 0,
              totalRecords: 0,
              loading: false,
            });
          }
        } catch (err) {
          this.setState({
            csvFileOneContent: [],
            totalPages: 0,
            totalRecords: 0,
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          errorFile: 'Invalid CSV File',
          csvFileOneContent: [],
          totalPages: 0,
          totalRecords: 0,
          loading: false,
        });
      });
  };

  closeDialog = () => {
    this.setState({ loadCsvDiffComponent: false });
    this.props.closeDialog();
  };

  renderCSVDiff = (instance, td, row, col, prop, value, cellProperties) => {

    if (this.state.csvFileTwoData[row] === undefined) {
      renderNewCell(instance, td, row, col, prop, value, cellProperties);
    } else if (this.state.csvFileOneData[row] === undefined) {
      renderNewCell(instance, td, row, col, prop, value, cellProperties);
    } else if (this.state.csvFileTwoData[row][col] === undefined) {
      renderNewCell(instance, td, row, col, prop, value, cellProperties);
    } else if (this.state.csvFileOneData[row][col] === undefined) {
      renderNewCell(instance, td, row, col, prop, value, cellProperties);
    } else {
      let fileOneRowColData = this.state.csvFileOneData[row][col];
      let fileTwoRowColData = this.state.csvFileTwoData[row][col];
      if (fileOneRowColData === fileTwoRowColData) {
        renderSameCell(instance, td, row, col, prop, value, cellProperties);
      } else if (fileOneRowColData !== fileTwoRowColData) {
        renderDiffCell(instance, td, row, col, prop, value, cellProperties);
      }
    }
  };



  handleChangeSelectDelimiter = (event) => {
    this.setState({
      myContent: this.state.myContent,
      delimiter: event.value
    });
    this.renderText(this.state.DownloadUrlFileOne)
  }
  render() {
    return (
      <div>
        <Dialog
          // fullScreen
          maxWidth='lg'
          fullWidth
          open={this.state.loadCsvDiffComponent}
          TransitionComponent={Transition}
        >
          <DialogTitle>
            <Box className='dialog-title-box'>
              <Typography variant='h5'>Compare Files</Typography>
              <div className='delimeter-wrapper-div'>
                <label className='delimeter-label'>Choose File Delimiter</label>
                <div className='delimeter-select-div'>
                  <Select
                    name='delimiterName'
                    styles={{
                      menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                    value={delimiteroptions.filter(
                      (item) => item.value === this.state.delimiter
                    )}
                    options={delimiteroptions}
                    onChange={this.handleChangeSelectDelimiter}
                    noValidate
                  />
                </div>
              </div>
              <Tooltip title='Close' placement='bottom'>
                <CloseIcon
                  className="cursor-pointer"
                  onClick={this.closeDialog}
                />
              </Tooltip>
            </Box>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <LoadingOverlay
              active={this.state.loading}
              spinner={
                <ScaleLoader
                  height={35}
                  width={5}
                  radius={2}
                  margin={2}
                  color={'#123abc'}
                  loading={this.state.loading}
                />
              }
            >
              <ResizablePanels
                displayDirection='row'
                width='100%'
                height='100vh'
                panelsSize={[50, 50]}
                sizeUnitMeasure='%'
                resizerColor='#D6D7DA'
                resizerSize='5px'
              >
                <div className='hot-table-div'>
                  {/* for removing prfix from the file name added in parent */}
                  <h6>
                    {this.props.selectedFiles?.[0]?.substring(
                      this.props.selectedFiles[0].indexOf('_') + 1
                    )}
                  </h6>
                 {this.state.csvFileTwoData?.length > 0 ? (
                    <HotTable
                      licenseKey={HandsonTableKey}
                      data={this.state.csvFileOneData}
                      colHeaders={true}
                      rowHeaders={true}
                      comments={true}
                      search={true}
                      settings={this.hotformula}
                      dropdownMenu={true}
                      multiColumnSorting={true}
                      filters={true}
                      manualRowMove={true}
                      stretchH='all'
                      width='100%'
                      minHeight='300px'
                      renderer={this.renderCSVDiff}
                    />
                  ) : null}
                </div>

                <div className='hot-table-div-2'>
                  {/* for removing prfix from the file name added in parent */}
                  <h6>
                    {this.props.selectedFiles?.[1]?.substring(
                      this.props.selectedFiles[1].indexOf('_') + 1
                    )}
                  </h6>
                  <HotTable
                    licenseKey={HandsonTableKey}
                    data={this.state.csvFileTwoData}
                    colHeaders={true}
                    rowHeaders={true}
                    comments={true}
                    search={true}
                    dropdownMenu={true}
                    multiColumnSorting={true}
                    filters={true}
                    settings={this.hotformula}
                    manualRowMove={true}
                    stretchH='all'
                    width='100%'
                    minHeight='300px'
                    renderer={this.renderCSVDiff}
                  />
                </div>
              </ResizablePanels>
            </LoadingOverlay>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

